import api, { Notifiable } from './api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';


export interface Esin204 extends Notifiable {
    id: string;
    ano: number;
    mes: number;
    dataInicio: Date;
    dataFim: Date;
    processado: boolean;
    cicloOrcamentarioId: string;
    processadoDescricao: string;
    totalRegistroEsin204: number;
    file: Blob;
    formData: any;
    alerMessage: AlerMessage[]
}

export interface AlerMessage {
    message: string
}

export interface RegistroEsin204 extends Notifiable {
    id: string;
    numOi: string;
    paraOi: number;
    itemEDescricao: string;
    codigoPacote: string;
    un: string;
    movimento: string;
    movimentoDateFormat: string;
    esp: string;
    tipo: string;
    serie: string;
    documento: string;
    fornecedor: string;
    fornecedorMrnDescricao: string;
    nomeFornecedor: string;
    natOper: string;
    quantidade: string;
    vlMarDolar: string;
    ordemCompra: number;
    icms: string;
    icmsPorcentagem: string;
    vlrTotal: string;
    aprop: string;
    narrativa: string;
    desconsiderarRelatorioAno: boolean;
    motivo: string;
    reclassificacaoProximoMes: boolean;
    verbaRemanescenteProvisao: boolean;
    fornecedorMrn: string;
    itemAlterado: boolean;
    contratoPcs: number;
    mensagemProcessoConsolidarExecutado: string;
    statusProcessoConsolidarExecutado: boolean
    statusProcessoConsolidarExecutadoDescricao: string;
    relatorioVlrTotalFormatado: string;
    statusProcessoCodigo: number;
}


export const getAllEsin204 = () => api.get<Esin204[]>('/esin204');
export const getAllRegistroEsin204ByEsin204Id = (id: any) => api.get<RegistroEsin204[]>(`esin204/getAllRegistroEsin204ByEsin204Id/${id}`);

export const updateRegistroEsin204 = (itensAlterados: RegistroEsin204[]) => {
    var itensAlteradosString = JSON.stringify(itensAlterados);
    const form = new FormData();
    form.append('itensAlterados', itensAlteradosString);
    return api.post<Notifiable>(`esin204/updateRegistroEsin204`, form);
}


export const habilitarEdicao = (id: any) => {
    return api.post<Notifiable>(`esin204/habilitarEdicao/${id}`);
}

export const consolidarExecutado = (id: any) => {
    return api.post<Notifiable>(`esin204/consolidarExecutado/${id}`,);
}

export const creatRateioAutomativo = (id: any) => {
    return api.post<Notifiable>(`esin204/creatRateioAutomativo/${id}`,);
}


export const getExportarLinhaReclassificacao = (id: any) => {
    let urlBase = window.location.origin;
    trackPromise(
        Axios.get(
            urlBase +
            `/api/esin204/exportarLinhaReclassificacao/${id}`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${getJwt()}`,
                },
            },
        ).then(resp => {

            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'linhasDeReclassificao.xlsx');
            link.setAttribute('id', 'downloadElement');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElement').outerHTML = '';
        }),
    );
}

export const getValidarExportarLinhaReclassificacao = (id: any) => {
    return api.get<boolean>(`/esin204/validarExportarLinhaReclassificacao/${id}`)
}

export const postImportacaoRelatorioiIn204 = (values: Esin204, file: any) => {
    const form = new FormData();
    form.append('id', values.id);
    form.append('file', file);

    if (values.dataInicio)
        form.append('dataInicio', values.dataInicio.toString());

    if (values.dataFim)
        form.append('dataFim', values.dataFim.toString());

    return api.post<Esin204>(`esin204`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}


export const exportarRegistroEsin204ByEsin204Id = (id: any) => {
    let urlBase = window.location.origin;
    trackPromise(
        Axios.get(
            urlBase +
            `/api/esin204/exportarRegistroEsin204ByEsin204Id/${id}`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${getJwt()}`,
                },
            },
        ).then(resp => {

            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'executadoMesAno.xlsx');
            link.setAttribute('id', 'downloadElementexecutadoMesAno');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElementexecutadoMesAno').outerHTML = '';
        }),
    )
};